import {Entity} from '@s-ui/domain'

export class CommentEntity extends Entity {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.id
   * @param {Object} data.author
   * @param {String} data.author.name
   * @param {String} data.author.photoUrl
   * @param {String} data.text
   * @param {String} data.date
   * @param {Array<CommentEntity>} data.answers
   */

  toJSON() {
    const answersEntities = this._answers && this._answers.map(answer => answer.toJSON())

    return {
      id: this._id,
      author: this._author,
      text: this._text,
      date: this._date,
      ...(this._answers && {answers: answersEntities})
    }
  }
}
